import React from 'react';
import { ExerciseDetails } from "@/components/Exercises";

export const ExerciseDetailPage = () => {
    return <ExerciseDetails />;
};